export const ERROR_TOAST_DURATION = 10_000;
